import React from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "../auth/authProvider";
import App from "./components/App";
/* Office.js is loaded from CDN in index.html */
Office.onReady(() => {
    const container = document.getElementById("root");
    if (!container) {
        throw new Error("Root element not found");
    }
    const root = createRoot(container);
    root.render(React.createElement(React.StrictMode, null,
        React.createElement(AuthProvider, null,
            React.createElement(App, null))));
});
